import { render, staticRenderFns } from "./TickerBanner.vue?vue&type=template&id=5818e9de&scoped=true"
import script from "./TickerBanner.vue?vue&type=script&lang=js"
export * from "./TickerBanner.vue?vue&type=script&lang=js"
import style0 from "./TickerBanner.vue?vue&type=style&index=0&id=5818e9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818e9de",
  null
  
)

export default component.exports